export const TRIGGER_ELEMENT_NAME = 'pimster-trigger';
